import { Link } from "react-router-dom";
import { SiteLayout } from "../components/site/SiteLayout";
import { Hero } from "../components/site/Sections";
import { WhyUs, Coverage, Clients, PromoPopup } from "../components/site/Sections2";
import { usePrefs } from "../context/PrefsContext";

export default function Home() {
  const { t } = usePrefs();
  return (
    <SiteLayout>
      {(content) => (
        <div data-testid="home-page">
          <PromoPopup popup={content.popup} />
          <Hero hero={content.hero} image={content.images?.hero} video={content.images?.hero_video} posY={content.images?.hero_pos_y} />
          <WhyUs values={content.values} />
          <Clients clients={content.clients} />
          <Coverage coverage={content.coverage} />
          <section
            data-testid="home-cta-parallax"
            className="relative py-32 lg:py-44 px-6 text-center bg-cover bg-center bg-fixed"
            style={{
              backgroundImage:
                "url(/cta-truck.png)",
            }}
          >
            <div className="absolute inset-0 bg-slate-950/75" />
            <div className="relative max-w-3xl mx-auto">
              <span className="inline-block text-orange-400 border border-orange-500/40 bg-orange-500/10 rounded-full px-4 py-1.5 text-xs tracking-widest uppercase font-semibold mb-6">
                Trusted Routes. Regional Reach.
              </span>
              <h2 className="font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6">
                {t.cta.heading}
              </h2>
              <p className="text-slate-300 mb-10 max-w-xl mx-auto">{t.cta.desc}</p>
              <Link
                to="/hubungi"
                data-testid="home-bottom-cta"
                className="inline-block bg-orange-600 hover:bg-orange-700 text-white font-semibold px-10 py-4 rounded-full transition-all hover:-translate-y-0.5 shadow-2xl shadow-orange-600/30"
              >
                {t.cta.button}
              </Link>
            </div>
          </section>
        </div>
      )}
    </SiteLayout>
  );
}
